import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('users'),
    component: () => import('@/views/UsersManagement.vue'),
  },
  {
    // Own route (not just a tab) so the Blocklist view survives a reload (F5).
    ...screen('users-blocklist'),
    component: () => import('@/views/UsersManagement.vue'),
  },
  {
    ...screen('users-deactivation'),
    component: () => import('@/views/UsersManagement.vue'),
  },
  {
    ...screen('users-edit'),
    component: () => import('@/views/UsersEdit.vue'),
  },

  // redirects
  {
    path: '/usuarios/digitadores/:id',
    redirect: { name: 'users-edit' },
  },
];
